import Image from 'next/image'

import { GridItem } from '../../components/grid-container'

import styles from './FaqTabUpdated.module.scss'

type Props = {
	tabTitle: string
	text: string
	imgSrc: string
	handleSetSelectedTab(tabTitle: string): void
}

const DESKTOP_IMAGE_SIZE = 40
const MOBILE_IMAGE_SIZE = 40

const FAQTabUpdated = ({ tabTitle, text, imgSrc, handleSetSelectedTab }: Props) => {
	return (
		<GridItem className={styles.faqGridItem}>
			{}
			<div className={styles.container} onClick={() => handleSetSelectedTab(tabTitle)}>
				<div className={styles.image}>
					<Image
						src={imgSrc}
						alt={text}
						fill
						sizes={`(max-width: 599px) ${MOBILE_IMAGE_SIZE}px, ${DESKTOP_IMAGE_SIZE}px`}
						priority
					/>
				</div>
				<span className={styles.title}>{text}</span>
			</div>
		</GridItem>
	)
}

export default FAQTabUpdated
